const Actions = require('common/domain/action/index');
const GroupActionCreator = require('common/domain/action/group');
const Dispatcher = require('common/domain/repository/dispatcher');
const GroupModel = require('common/domain/entity/group');
const ModalBaseView = require('common/ui/view/modal/base');
const GroupCreateViewTemplate = require('balus/ui/template/global-menu/modal/group-create.hbs');
const Time = require('common/util/time');
const i18n = require('i18next');
require('backbone.stickit');
require('bootstrap');

module.exports = ModalBaseView.extend({
    tagName: 'div',
    id: 'group-create-view',

    bindings: {
        'input.name': 'name'
    },

    modelEvents: {
        'change:name': 'uploadable'
    },

    initialize: function() {
        _.bindAll(this, 'setting', 'success', 'error');
        this.model = new GroupModel();
    },

    resetModel: function() {
        this.unstickit();
        this.model = new GroupModel();
        this.listenTo(this.model, 'invalid', this.setErrors);
        this.stickit();
    },

    render: function() {
        const json = this.model.toJSON();
        this.$el.html($(GroupCreateViewTemplate(json)));

        this.setupModal();
        this.stickit();

        return this;
    },

    setting: function() {
        return new Promise((resolve, reject) => {
            GroupActionCreator.createGroup({
                group: this.model.toJSON()
            })
                .then((data) => {
                    this.success(data);
                    resolve();
                })
                .catch((status) => {
                    this.error(status);
                    reject();
                });
        });
    },

    uploadable: function () {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    error: function(status) {
        if (status && status.type == 'EmptyNameError') {
            this.$('.name .alert-message').html(
                i18n.t('input.group.validation.required')
            );
        }
    },

    success: function(data) {
        Dispatcher.dispatch({
            type: Actions.CREATE_RECENT_CHANGE,
            kind: 'Group',
            recentChange: {
                updated_at: Time.dumps(Time.now()),
                kind: 'Group',
                target: data
            }
        });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/global-menu/modal/group-create.js